<!-- 医疗案例 -->
<template>
  <div class="case">
    <h4 class="current">
      您的位置：<router-link to="/home">首页 </router-link> &gt;产品与方案 &gt; 政企协同管控解决方案
    </h4>
    <div class="article">
      <h5>政企协同管控解决方案</h5>
      <h4 class="smalltit">产品背景</h4>
      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;近些年政企客户业务已经成为电信业务的重点发展方向，市场发展潜力巨大。同时，来自其他运营商、互联网公司和IT服务商的竞争，也带来前所未有的压力。在这种情况下，提供优质服务，优化现有工作支撑体系、提升团队销售能力成为当下的工作重点。
      </p>
      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;目前，在政企客户服务过程中还存在不少问题，尤其在整个项目进度管控，资源协调，团队沟通等方面需要进一步优化改进，让前端人员更专注，让中间环节更可控，让售后服务更满意。
      </p>

      <h4 class="smalltit">产品解决的问题</h4>
      <p>
        <span class="boldblack">1.售前环节</span><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;支撑经理花费大量经历在协调项目各个环节，本职工作不能更好的支撑。支撑经理在售前工作过程中需要后端资源协助（比如设备报价）。支撑经理工作积极性需要调动。
        <br />
        <span class="boldblack">2.售中环节</span><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;客户经理不了解项目建设进度，当项目进度出现问题时不清楚谁负责。分公司在建设项目过程中出现问题直接联系省政企支撑经理，导致支撑经理承担了大量售中工作。地市资源核查工作不到位，项目立项后无法再进行拨款申请。项目完工后没有验收单，验收没有依据，和用户容易出现扯皮。
        <br />
        <span class="boldblack">3.售后环节</span><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;非故障类需要走OA或工单，处理繁琐。客户出现问题时频繁联系客户经理解决问题，客户经理变成了售后人员。<br />
      </p>
      <h4 class="smalltit">平台建设价值</h4>
      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;系统建设后，能够优化客户经理、支撑经理、项目经理、客户经理的角色智能，使他们更专注本职工作，同时项目过程更加清晰，避免由此产生的无效沟通，通过整体项目的管控，让用户体验更好，服务团队支撑更加专业。
      </p>
      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;客户经理：客户经理能腾出更多精力拓展业务和服务客户。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;支撑经理：支撑经理能节约大量的时间提供售前方案和投标文件。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;项目经理：项目经理能够方便的把控项目进度，起到承上启下的作用。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;运维经理：运维部门能够减少盯项目进度的人员，抢单制度能够大大提升运维人员工作的积极性。
      </p>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {}
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
h4.current {
  display: block;
  height: 40px;
  line-height: 30px;
  background: url(../../../assets/currentbg.jpg) repeat-x bottom;
  color: #333;
}
h4.current a:hover {
  color: #e90000;
}
.article h5 {
  display: block;
  text-align: center;
  line-height: 60px;
  font-size: 30px;
  color: #333;
  margin-top: 40px;
}
.article h6 {
  display: block;
  text-align: center;
  font-size: 14px;
  color: #888;
  margin-top: 5px;
  margin-bottom: 30px;
}
.smalltit {
  display: block;
  height: 55px;
  line-height: 55px;
  margin-top: 20px;
  padding-left: 35px;
  background: url(../../../assets/ico01.png) no-repeat left center;
  font-size: 22px;
  color: #e60212;
}
.intro p {
  line-height: 30px;
}
.intro img {
  display: block;
  margin: 0 auto;
}
.article img {
  margin: 0 auto;
  display: block;
  margin-top: 15px;
}
.article p {
  margin-top: 15px;
  line-height: 30px;
  margin: 15px 0;
}
.boldblack {
  color: #333;
  font-weight: bold;
}
.boldred {
  color: #f00;
  font-weight: bold;
}
.font18 {
  font-size: 18px;
}
</style>
